import React from 'react'
import './theme.scss'

export function CancelButton({ clickAction, label }) {
    return (
        <div className="button button--secondary button--cancel" onClick={clickAction}>
            {label}
        </div>
    )
}
